import { jsx as _jsx } from "react/jsx-runtime";
import { Nav } from '@fluentui/react';
import { useAppShell } from '../AppShellContext';
import { useHistory, useLocation } from 'react-router-dom';
import { useThemeData } from '@msrceng/theme';
/**
 * Renders an array of links in a Fluent UI `Nav` component
 */
const AppSidebarNav = () => {
    const { appLinksWithHome, isAppSidebarExpanded } = useAppShell();
    const { push } = useHistory();
    const location = useLocation();
    const { theme: { palette, semanticColors }, } = useThemeData();
    const links = appLinksWithHome.map(({ iconName, name, url }) => ({
        iconProps: { iconName },
        key: name,
        name,
        isExpanded: isAppSidebarExpanded,
        onClick: event => {
            event === null || event === void 0 ? void 0 : event.preventDefault();
            push(Object.assign(Object.assign({}, location), { pathname: url }));
        },
        url,
    }));
    const getSelectedKey = () => {
        var _a;
        const selectedLinks = links.filter(({ url }) => url === location.pathname);
        return (_a = selectedLinks[0]) === null || _a === void 0 ? void 0 : _a.key;
    };
    return (_jsx(Nav, { groups: [{ links }], selectedKey: getSelectedKey(), styles: {
            linkText: {
                display: isAppSidebarExpanded ? undefined : 'none',
            },
            link: {
                color: semanticColors.actionLink,
                transition: 'none',
                padding: '0 8px',
                selectors: {
                    '.ms-Button-icon': {
                        color: 'inherit',
                    },
                },
            },
            root: {
                selectors: {
                    '.is-selected .ms-Nav-link': {
                        background: palette.neutralQuaternaryAlt,
                    },
                },
            },
        } }));
};
// Exports
// -------
export { AppSidebarNav };
